import React from "react";
import { Space, Select, Col, Row } from "antd";

const MissionFilters = ({ filters, onFiltersChange }) => {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <span>Type</span>
          <Select
            placeholder="ALL"
            allowClear
            style={{ width: "100%" }}
            onChange={(value) =>
              onFiltersChange({ ...filters, type: value })
            }
          >
            <Select.Option value="FIRST_ORDER">First completed order</Select.Option>
            <Select.Option value="ORDER_COUNT_MILESTONE">Nth completed orders milestone</Select.Option>
            <Select.Option value="MONTHLY_SPEND">Monthly spend milestone</Select.Option>
          </Select>
        </Space>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6}>
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <span>Status</span>
          <Select
            placeholder="ALL"
            allowClear
            style={{ width: "100%" }}
            onChange={(value) =>
              onFiltersChange({ ...filters, isActive: value })
            }
          >
            <Select.Option value={true}>Active</Select.Option>
            <Select.Option value={false}>Inactive</Select.Option>
          </Select>
        </Space>
      </Col>
    </Row>
  );
};

export default MissionFilters;
